import React, { useState } from "react";
import Countdown, { zeroPad } from "react-countdown";
import { BsEmojiFrown } from "react-icons/bs";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const CountdownCustom = ({ date, onComplete = () => {} }) => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const render = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <span style={{ fontSize: 20, color: "red" }}>Hết Thời Gian !</span>
        </div>
      );
    } else {
      return (
        <span style={{ fontSize: 20 }}>
          {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
      );
    }
  };
  // -------------------------- MAIN ----------------------------
  if (!date) return null;
  return <Countdown onComplete={onComplete} date={date} renderer={render} />;
};
export default CountdownCustom;
